export default {
  namespaced: true,
  state: () => ({
    uploadMethod: "default",
    uploadCopyUrlForm: "",
    uploadChannel: "",
    uploadFolder: "",
    uploadNameType: "",
    autoRetry: false,

    compressConfig: {
      customerCompress: false,
      compressQuality: 5,
      compressBar: 10,
      serverCompress: false,
    },

    customUrlSettings: {
      useCustomUrl: false,
      customUrlPrefix: "",
    },
  }),
  getters: {
    storeUploadMethod: (state) => state.uploadMethod,
    storeUploadCopyUrlForm: (state) => state.uploadCopyUrlForm,
    storeCompressConfig: (state) => state.compressConfig,
    storeUploadChannel: (state) => state.uploadChannel,
    storeAutoRetry: (state) => state.autoRetry,
    storeUploadNameType: (state) => state.uploadNameType,
    storeCustomUrlSettings: (state) => state.customUrlSettings,
    storeUploadFolder: (state) => state.uploadFolder,
  },
  mutations: {
    setUploadMethod(state, value) {
      state.uploadMethod = value;
    },
    setUploadCopyUrlForm(state, value) {
      state.uploadCopyUrlForm = value;
    },
    setUploadChannel(state, value) {
      state.uploadChannel = value;
    },
    setUploadNameType(state, value) {
      state.uploadNameType = value;
    },
    setUploadFolder(state, folder) {
      state.uploadFolder = folder;
    },
    setCompressConfig(state, { key, value }) {
      state.compressConfig[key] = value;
    },
    setAutoRetry(state, value) {
      state.autoRetry = value;
    },
    setCustomUrlSettings(state, { key, value }) {
      state.customUrlSettings[key] = value;
    },
  },
};
